import { UseQueryResult } from "@tanstack/react-query";

export const FAILED_NETWORK_HTTP_STATUS = 0;

export type SuccessResponseType<T> = Extract<T, { success: true }>;

export function getInnerQueryData<T>(
  query: UseQueryResult<{ data: T }>,
): T | null {
  if (query.isSuccess) return query.data.data;

  return null;
}

export function getQueryData<T>(query: UseQueryResult<T>): T | null {
  return query.isSuccess ? query.data : null;
}
